module.exports = __webpack_public_path__ + "img/categories-5.97879d61.jpg";